"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mobx_react_1 = require("mobx-react");
require("../index.scss");
const WriterCardEditable_1 = __importDefault(require("@Components/Cards/WorkDetailCards/WriterCards/WriterCardEditable"));
const entities_validators_1 = require("@App/helpers/work-entities/entities-validators");
const removers_1 = require("@App/helpers/work-entities/removers");
const contexts_1 = require("@App/contexts");
const react_router_dom_1 = require("react-router-dom");
const fields_validators_1 = require("@App/helpers/work-entities/fields-validators");
const WritersSharesRoleStep = () => {
    const { workStore, libStore, rightsholderStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const removeWriter = (removingWriter) => {
        const workDraftFromLocal = workStore.workDraftLocal;
        if (!workDraftFromLocal) {
            return;
        }
        const updatedWorkDraft = (0, removers_1.writerRemover)(removingWriter, workDraftFromLocal);
        workStore.setWorkDraftToLocal(updatedWorkDraft);
    };
    const stepValidator = () => {
        const workDraftFromLocal = workStore.workDraftLocal;
        if (!workDraftFromLocal) {
            return;
        }
        const invalid = (0, entities_validators_1.writersInvalidCheck)(workDraftFromLocal.writers, libStore.writerRoles, workDraftFromLocal.isComplete);
        workStore.setWizardStepValidation(!invalid);
    };
    (0, react_1.useEffect)(() => {
        stepValidator();
    }, [workStore.workDraftLocal]);
    const currentRhId = rightsholderStore.currentRightsholderId;
    const workDraftFromLocal = workStore.workDraftLocal;
    if (!workDraftFromLocal || !currentRhId) {
        return null;
    }
    const typeCreator = location.href.split('/')[7]; // HARD CODE
    if (!workDraftFromLocal.writers.length) {
        if (workDraftFromLocal.id) {
            return (react_1.default.createElement(react_router_dom_1.Navigate, { to: `/rightsholder/${currentRhId}/catalog/${workDraftFromLocal.isComplete ? 'catalog' : 'draft'}/${workDraftFromLocal.id}/edit/writers` }));
        }
        return react_1.default.createElement(react_router_dom_1.Navigate, { to: `/rightsholder/${currentRhId}/create-work/manual/${typeCreator}/writers` });
    }
    return (react_1.default.createElement("div", { className: 'writers-step' },
        react_1.default.createElement("div", { className: "step-content" },
            react_1.default.createElement("div", { className: "main-title" },
                react_1.default.createElement("p", { className: 'bold title' },
                    "Writers (",
                    workDraftFromLocal.writers.length,
                    ")"),
                react_1.default.createElement("span", { className: "small bold blue-text" }, "Required")),
            react_1.default.createElement("div", { className: 'cards-wrapper' },
                react_1.default.createElement("div", { className: "cards-field" }, workDraftFromLocal.writers.map((data) => (react_1.default.createElement(WriterCardEditable_1.default, { key: data.localId, data: data, removeFunction: removeWriter, errorMessage: (0, fields_validators_1.isComposerPresent)(workDraftFromLocal.writers)
                        ? undefined
                        : 'At least one Composer/Author or Composer writer role is required to submit a work registration.' }))))))));
};
exports.default = (0, mobx_react_1.observer)(WritersSharesRoleStep);
